export default __webpack_public_path__ + "static/media/dis.b618ba65.svg";